/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {FileManagerApi} from '../../../api/ms-filemanager/filemanager.api';
import {ToastWrapperService} from '../../../shared/utils/toast-wrapper-service/toast-wrapper-service';
import {Subject} from 'rxjs';
import {DownloadIsOverModel} from './download-is-over.model';

@Injectable({
    providedIn: 'root'
})
export class FileDownloadHelperService {

    downloadIsOverSubject = new Subject<DownloadIsOverModel>();
    downloadIsOver = this.downloadIsOverSubject.asObservable();

    constructor(private fileManagerApi: FileManagerApi, private toast: ToastWrapperService) {
    }

    downloadFile(directory: string, filename: string): void {
        this.fileManagerApi.downloadFile(directory, filename)
                .subscribe((response) => {
                            const blob = new Blob([response]);
                            this.saveFile(blob, filename);
                        },
                        error => {
                            this.toast.error([
                                '<p>Due to a communication problem with the server, your request was not attended.</p>',
                                '<p><strong>Please try again later</strong></p>',
                            ].join('<br>'), 'Error');
                        }).add(() => {
            this.downloadIsOverSubject.next({fileName: filename, downloadIsOver: true});
        });
    }

    createFileAndDownload(filename: string, fileContent: string): void {
        this.saveFile(new Blob([fileContent], {type: 'text/plain'}), filename);
    }

    /**
     * Saves a file to the user machine
     * @param file The file to be downloaded
     * @param fileName The name of the file to be downloaded
     */
    private saveFile(file: Blob, fileName: string): void {
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(file);
        if (fileName) {
            downloadLink.setAttribute('download', fileName);
        }
        downloadLink.click();
        downloadLink.remove();
    }
}
